import React, { FC } from 'react';

import MultiSelectField from 'buyside/components/presentation/Fields/multiSelectField';
import Link from 'buyside/components/presentation/Link/link';

import { contestUrl } from 'buyside/util/urlHelper';

import { IdeaSubmissionQuery } from 'interfaces/graphql-typings';

import styles from '../disclaimersStyles.scss';

const ContestField: FC<{
  currentContests?: IdeaSubmissionQuery['currentContests'];
}> = ({ currentContests }) => {
  if (!currentContests?.length) return null;

  return (
    <MultiSelectField
      name="contests"
      label="contests"
      options={currentContests.map(({ id, name }) => ({
        label: (
          <>
            {name}
            <Link className={styles.contestDetailsLink} target="_blank" to={contestUrl(id)}>
              {' '}
              (View contest details)
            </Link>
          </>
        ),
        value: id
      }))}
    />
  );
};

export default ContestField;
